import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { CodeActionType, CodeItemWire } from './types';
import { codetableItemEndpoint } from 'app/area/indicator-factors/item/actions-helpers';

export const api = {
  loadCodeItem: async (codetableId: number, codeId: number): Promise<CodeItemWire> => {
    const request = await new RemoteAdminData(endpoints.code(codetableId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .withId(codeId)
      .single();

    return request.data;
  },

  createCodetableItem: async (actionType: CodeActionType, codetableId: number, codeId: number, codeItem: CodeItemWire) => {
    const request = await new RemoteAdminData(codetableItemEndpoint(actionType, codetableId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .create(codeItem);

    return request.data;
  },

  saveCodetableItem: async (codetableId: number, codeId: number, codeItem: CodeItemWire) => {
    const request = await new RemoteAdminData(endpoints.code(codetableId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .withId(codeId)
      .save(codeItem);

    return request.data;
  }
};
